var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosShareIconPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.5C3.17157 6.5 2.5 7.17157 2.5 8C2.5 8.82843 3.17157 9.5 4 9.5C4.82843 9.5 5.5 8.82843 5.5 8C5.5 7.17157 4.82843 6.5 4 6.5ZM1.5 8C1.5 6.61929 2.61929 5.5 4 5.5C5.38071 5.5 6.5 6.61929 6.5 8C6.5 9.38071 5.38071 10.5 4 10.5C2.61929 10.5 1.5 9.38071 1.5 8Z",
    fill: "#EB5B5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C10.1716 11 9.5 11.6716 9.5 12.5C9.5 13.3284 10.1716 14 11 14C11.8284 14 12.5 13.3284 12.5 12.5C12.5 11.6716 11.8284 11 11 11ZM8.5 12.5C8.5 11.1193 9.61929 10 11 10C12.3807 10 13.5 11.1193 13.5 12.5C13.5 13.8807 12.3807 15 11 15C9.61929 15 8.5 13.8807 8.5 12.5Z",
    fill: "#EB5B5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C10.1716 2 9.5 2.67157 9.5 3.5C9.5 4.32843 10.1716 5 11 5C11.8284 5 12.5 4.32843 12.5 3.5C12.5 2.67157 11.8284 2 11 2ZM8.5 3.5C8.5 2.11929 9.61929 1 11 1C12.3807 1 13.5 2.11929 13.5 3.5C13.5 4.88071 12.3807 6 11 6C9.61929 6 8.5 4.88071 8.5 3.5Z",
    fill: "#EB5B5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73935 4.31093C9.88864 4.54324 9.82133 4.85259 9.58902 5.00187L5.95152 7.33937C5.71921 7.48866 5.40986 7.42135 5.26058 7.18904C5.11129 6.95673 5.1786 6.64739 5.41091 6.4981L9.04841 4.1606C9.28072 4.01132 9.59006 4.07862 9.73935 4.31093Z",
    fill: "#EB5B5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26058 8.81093C5.40986 8.57862 5.71921 8.51132 5.95152 8.6606L9.58902 10.9981C9.82133 11.1474 9.88864 11.4567 9.73935 11.689C9.59006 11.9214 9.28072 11.9887 9.04841 11.8394L5.41091 9.50187C5.1786 9.35259 5.11129 9.04324 5.26058 8.81093Z",
    fill: "#EB5B5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosShareIconPink);
export default __webpack_public_path__ + "static/media/IosShareIconPink.b6b19c40b1343f4f1104c49d0850529f.svg";
export { ForwardRef as ReactComponent };